module.exports = __webpack_public_path__ + "img/my-wallet.2030c0bc.svg";